export class UpdateBancoRequest {
  public id!: number
  public descripcion!: string
}
